import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1146bcae"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = {
  key: 0,
  class: "news"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "news-cen-left" }
const _hoisted_5 = { class: "news-cen-left-title" }
const _hoisted_6 = { class: "news-cen-left-time ovehide" }
const _hoisted_7 = { class: "news-cen-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode($setup["Loading"], { loading: $setup.loading }, null, 8 /* PROPS */, ["loading"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_pull_refresh, {
        modelValue: $setup.loadingsta,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.loadingsta) = $event)),
        onRefresh: $setup.onRefresh
      }, {
        default: _withCtx(() => [
          _createVNode(_component_van_list, {
            modelValue: $setup.isLoading,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.isLoading) = $event)),
            finished: $setup.finished,
            offset: "300",
            "immediate-check": false,
            onLoad: $setup.onLoad
          }, {
            default: _withCtx(() => [
              ($setup.newsList.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.newsList, (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "news-cen",
                        key: index,
                        onClick: ($event: any) => ($setup.newslist(item))
                      }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("p", _hoisted_5, _toDisplayString(item.title), 1 /* TEXT */),
                          _createElementVNode("p", _hoisted_6, _toDisplayString($setup.formatNewsTime(item.publishedAt)) + " " + _toDisplayString(_ctx.$t('home.pushlish')), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                          _createVNode(_component_van_image, {
                            fit: "cover",
                            "lazy-load": "",
                            src: item.coverPicture
                          }, null, 8 /* PROPS */, ["src"])
                        ])
                      ], 8 /* PROPS */, _hoisted_3))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["modelValue", "finished"])
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["modelValue"])
    ])
  ], 64 /* STABLE_FRAGMENT */))
}